/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */

import CommentsSection from '../../common/CommentsSection';

const FRY7QComment = ({
    getFRY7QUser, fry7qComment, setFRY7QComment, commentLoading, addFRY7QComment,
    loading, getUserCommentsForFRY7Q, fry7qEdit, handleFRY7QClick, fry7qShow,
    fry7qTarget, onFRY7QEditClick, onFRY7QClickDelete, fry7qSelectedIndex,
    fry7qSelectedComment, setFRY7QSelectedComment, onFRY7QCancelClick, onFRY7QClickSave,
}) => (
    <CommentsSection
        getUser={getFRY7QUser}
        comment={fry7qComment}
        setComment={setFRY7QComment}
        commentLoading={commentLoading}
        addComment={addFRY7QComment}
        loading={loading}
        getUserComments={getUserCommentsForFRY7Q}
        edit={fry7qEdit}
        handleClick={handleFRY7QClick}
        show={fry7qShow}
        target={fry7qTarget}
        onEditClick={onFRY7QEditClick}
        onClickDelete={onFRY7QClickDelete}
        selectedIndex={fry7qSelectedIndex}
        selectedComment={fry7qSelectedComment}
        setSelectedComment={setFRY7QSelectedComment}
        onCancelClick={onFRY7QCancelClick}
        onClickSave={onFRY7QClickSave}
    />
);

export default FRY7QComment;
